import { CircleX } from 'lucide-react';

interface SearchClearButtonProps {
  label: string;
  onClick: () => void;
}

function focusSearchField(button: HTMLButtonElement) {
  const holder = button.parentElement;
  const field = holder?.querySelector('input') ?? holder?.parentElement?.querySelector('input');
  if (field instanceof HTMLInputElement) field.focus();
}

/**
 * Clears the text in an Aspen search field.
 * The parent shows this button only when the field has text.
 */
export function SearchClearButton({ label, onClick }: SearchClearButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      className="pointer-events-auto text-foreground-secondary hover:text-foreground"
      // A pointer press moves focus to this button. Cancel that press so the caret stays.
      onMouseDown={(event) => event.preventDefault()}
      onClick={(event) => {
        // A keyboard press focuses this button. Focus the field before the button unmounts.
        focusSearchField(event.currentTarget);
        onClick();
      }}
    >
      <CircleX />
    </button>
  );
}
